/**
 * Инициализирует функциональность плавной прокрутки вниз страницы
 */
export function initSlideBottom(): void {
  const triggers = document.querySelectorAll('[data-slide-bottom]')

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      window.scrollTo({
        top: 800,
        behavior: 'smooth'
      })
    })
  })
}
